import { isDateFuture } from '../../../../utils/dateFunctions';
import { checkDiff } from '../../../../utils/formValidation/errorCheckingFunctions';
import {
    getNowDateOrEarlierMessage,
    getReqMessage,
    getSelectMessage
} from '../../../../utils/formValidation/errorMessageFunctions';

const MIN_CM_HEIGHT = 100;
const MAX_CM_HEIGHT = 250;
const MIN_IMPERIAL_HEIGHT = '3ft 4in';
const MAX_IMPERIAL_HEIGHT = '8ft 2in';
export const MAX_INS_HEIGHT = 11;

const MIN_KG_WEIGHT = 35;
const MAX_KG_WEIGHT = 300;
const MIN_IMPERIAL_WEIGHT = '6st';
const MAX_IMPERIAL_WEIGHT = '47st 13lb';
export const MAX_LBS_WEIGHT = 13;

export const MIN_HEIGHT_WARNING = `Height is lower than ${MIN_CM_HEIGHT}cm. Please confirm`;
export const MAX_HEIGHT_WARNING = `Height is higher than ${MAX_CM_HEIGHT}cm. Please confirm`;
export const MIN_WEIGHT_WARNING = `Weight is lighter than ${MIN_KG_WEIGHT}kg. Please confirm`;
export const MAX_WEIGHT_WARNING = `Weight is heavier than ${MAX_KG_WEIGHT}kg. Please confirm`;

export const MIN_IMPERIAL_HEIGHT_WARNING = `Height is lower than ${MIN_IMPERIAL_HEIGHT}. Please confirm`;
export const MAX_IMPERIAL_HEIGHT_WARNING = `Height is higher than ${MAX_IMPERIAL_HEIGHT}. Please confirm`;
export const MIN_IMPERIAL_WEIGHT_WARNING = `Weight is lighter than ${MIN_IMPERIAL_WEIGHT}. Please confirm`;
export const MAX_IMPERIAL_WEIGHT_WARNING = `Weight is heavier than ${MAX_IMPERIAL_WEIGHT}. Please confirm`;

export const checkHeightWarnings = (value, warnings, isImperialHeight) => {
    let warning = false;
    let message = '';
    if (value > 0 && value < MIN_CM_HEIGHT) {
        warning = true;
        message = isImperialHeight ? MIN_IMPERIAL_HEIGHT_WARNING : MIN_HEIGHT_WARNING;
    } else if (value > MAX_CM_HEIGHT) {
        warning = true;
        message = isImperialHeight ? MAX_IMPERIAL_HEIGHT_WARNING : MAX_HEIGHT_WARNING;
    }
    return { ...warnings, height: { warning, message } };
};

export const checkWeightWarnings = (value, warnings, isImperialWeight) => {
    let warning = false;
    let message = '';
    if (value > 0 && value < MIN_KG_WEIGHT) {
        warning = true;
        message = isImperialWeight ? MIN_IMPERIAL_WEIGHT_WARNING : MIN_WEIGHT_WARNING;
    } else if (value > MAX_KG_WEIGHT) {
        warning = true;
        message = isImperialWeight ? MAX_IMPERIAL_WEIGHT_WARNING : MAX_WEIGHT_WARNING;
    }
    return { ...warnings, weight: { warning, message } };
};

export const validate = (newEntry, formType, initialRow) => {
    let newErrors = {};

    if (!newEntry.eventDate) {
        newErrors = {
            ...newErrors,
            eventDate: { error: true, message: getReqMessage('Event date') }
        };
    } else if (isDateFuture(newEntry.eventDate)) {
        newErrors = {
            ...newErrors,
            eventDate: { error: true, message: getNowDateOrEarlierMessage() }
        };
    }

    if (!newEntry.height || newEntry.height < 1) {
        newErrors = {
            ...newErrors,
            height: { error: true, message: getReqMessage('Height') }
        };
    }

    if (!newEntry.weight || newEntry.weight < 1) {
        newErrors = {
            ...newErrors,
            weight: { error: true, message: getReqMessage('Weight') }
        };
    }

    if (!newEntry.measurementId) {
        newErrors = {
            ...newErrors,
            measurementId: { error: true, message: getSelectMessage('measurement type') }
        };
    }

    if (formType === 'edit' && Object.keys(newErrors).length < 1) {
        newErrors = checkDiff(newEntry, initialRow);
    }
    return newErrors;
};
